import { Table, Form, Row, Col, Button } from "antd";
import { DatePicker as DatePickerJalali, Calendar, JalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import { convertToGregorian, convertToJalaliWithTime, formatTime, validateInput } from "../../../../tools/tools";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTenders } from "../../../../tools/api";
import { _adr } from "../../../../address";
const Tables = () => {
  const [t] = useTranslation("global");
  const [frmSearch] = Form.useForm();

  const { queryCurrentUserBids } = useTenders();

  const [isActiveeSearchButton, setIsActiveeSearchButton] = useState(false);

  const [isLoadingList, setIsLoadingList] = useState(false);
  const [bTable, setBTable] = useState([]);
  //state current page show Records
  const [currentPage, setCurrentPage] = useState(0);
  // state totalRecord
  const [totalRecord, setTotalRecord] = useState(0);

  const handleSearch = async (value) => {
    try {
      setIsActiveeSearchButton(true);
      setIsLoadingList(true);
      let payload = {
        auctionstatus: [0, 2, 3, 5],
        dateto: convertToGregorian(value?.duringdate[1].format("YYYY-MM-DD"), "-", "-"),
        datefrom: convertToGregorian(value?.duringdate[0].format("YYYY-MM-DD"), "-", "-"),
        searchconfigmodel: {
          sort: "",
          filter: "",
          entriesperpage: 10,
          page: currentPage === 0 ? 0 : currentPage - 1,
          totalrowcount: 0,
        },
      };
      let response = await queryCurrentUserBids(payload);
      if (response?.Result) {
        setBTable(
          response.Result.map((item, key) => ({
            key: key,
            msisdnType: item?.auctionProductType,
            msisdn: item?.auctionTitle,
            maxprice: item?.maxBid,
            preferprice: item?.userBid,
            datetime: <span dir="ltr">{convertToJalaliWithTime(item?.startDate, "-") + " - " + formatTime(new Date(item?.startDate))}</span>,
            expiretime: <span dir="ltr">{convertToJalaliWithTime(item?.endDate, "-") + " - " + formatTime(new Date(item?.endDate))}</span>,
            status: <>{item?.hasWon ? <span>برنده</span> : <>برنده نشده</>}</>,
            action: (
              <>
                <Link to={_adr.Root + _adr.Landing.Index + _adr.Landing.Details + `?id=${item?.auctionProductId}`}>جزئیات</Link>
              </>
            ),
          })),
        );
        setTotalRecord(response?.searchconfigmodel?.totalrowcount);
      }
      setIsLoadingList(false);
    } catch (error) {
      console.error(error);
      setIsLoadingList(false);
    }
  };

  useEffect(() => {
    const callServices = async () => {
      try {
        let valid = await frmSearch.validateFields();
        if (valid) {
          let value = {
            duringdate: frmSearch.getFieldValue("duringdate"),
          };
          handleSearch(value);
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (isActiveeSearchButton) callServices();
  }, [currentPage]);

  return (
    <>
      <Form form={frmSearch} onFinish={handleSearch} layout="vertical">
        <Row gutter={30}>
          <Col>
            <JalaliLocaleListener />
            <Form.Item name="duringdate" label="انتخاب تاریخ" rules={[validateInput({ t: t, validate: true, typeOfValue: "array" })]}>
              <DatePickerJalali.RangePicker format={"YYYY/MM/DD"} />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label={<></>}>
              <div className="holder-button">
                <Button htmlType="submit" className="btn-green">
                  جستجو
                </Button>
              </div>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <div className="holder_table">
        <Table
          columns={[
            {
              title: "نوع سیم کارت",
              dataIndex: "msisdnType",
              key: "msisdnType",
              width: 150,
            },
            {
              title: "شماره ",
              dataIndex: "msisdn",
              key: "msisdn",
              width: 150,
            },
            {
              title: "بالاترین پیشنهاد",
              dataIndex: "maxprice",
              key: "maxprice",
              width: 150,
            },
            {
              title: "پیشنهاد شما",
              dataIndex: "preferprice",
              key: "preferprice",
              width: 150,
            },
            {
              title: "تاریخ برگزاری",
              dataIndex: "datetime",
              key: "datetime",
              width: 150,
            },
            {
              title: "تاریخ پایان",
              dataIndex: "expiretime",
              key: "expiretime",
              width: 150,
            },
            {
              title: "وضعیت",
              dataIndex: "status",
              key: "status",
              width: 150,
            },
            {
              title: "",
              dataIndex: "action",
              key: "action",
              width: 150,
            },
          ]}
          loading={isLoadingList}
          scroll={{ y: "auto" }}
          pagination={{
            onChange: (page) => {
              setCurrentPage(page);
            },
            hideOnSinglePage: true,
            pageSize: 10,
            align: "start",
            current: currentPage === 0 ? 1 : currentPage,
            total: totalRecord,
            showSizeChanger: false,
          }}
          dataSource={bTable}
        ></Table>
      </div>
    </>
  );
};

export default Tables;
